<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.375 8.59375H7.8125C6.51808 8.59375 5.46875 9.64308 5.46875 10.9375V20.3125C5.46875 21.6069 6.51808 22.6562 7.8125 22.6562H17.1875C18.4819 22.6562 19.5312 21.6069 19.5312 20.3125V10.9375C19.5312 9.64308 18.4819 8.59375 17.1875 8.59375H15.625M9.375 12.5L12.5 15.625M12.5 15.625L15.625 12.5M12.5 15.625L12.5 2.34375"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgDownloads',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
